var _path, _path2, _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSupport = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  d: "M4 10a8 8 0 1 1 16 0v5a6 6 0 0 1-6 6h-2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 9a2 2 0 0 1 2-2h3v7H2a2 2 0 0 1-2-2zM19 7h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-3z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 4,
  x: 9,
  y: 19,
  fill: "currentColor",
  rx: 1
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 12,
  r: 1,
  fill: "currentColor"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 1,
  fill: "currentColor"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 12,
  r: 1,
  fill: "currentColor"
})));
export default SvgSupport;